import actions from '../actions/carouselActions';

// Middleware for Carousel
function selectNextImage(store, action) {
    const {currentIndex, numImages} = action.payload;
    let newIndex;

    if (currentIndex === numImages - 1) {
        newIndex = 0;
    } else {
        newIndex = currentIndex + 1;
    }

    store.dispatch(actions.changeImageIndex(newIndex));
}

function selectPrevImage(store, action) {
    const {currentIndex, numImages} = action.payload;
    let newIndex;

    if (currentIndex === 0) {
        newIndex = numImages - 1;
    } else {
        newIndex = currentIndex - 1;
    }

    store.dispatch(actions.changeImageIndex(newIndex));
}

export {selectNextImage, selectPrevImage};
